<template>
    <div>
        <div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="2500">
            <!-- 轮播（Carousel）指标 -->
            <ol class="carousel-indicators">
                <li v-for="(img,index) in carousel[$i18n.locale]" :key="index" data-target="#myCarousel" :data-slide-to="index" 
                :class="[index == 0 ? 'active' : '']">
                </li>
            </ol>   
            <!-- 轮播（Carousel）项目 -->
            <div class="carousel-inner" >
                <div v-for="(img,index) in carousel[$i18n.locale]" :key="img.id" class="item" :class="[index == 0 ? 'active': '']">
                    <img :src="img.imgUrl" alt="" v-if="isShow">
                    <img :src="img.imgUrlM" alt="" v-if="!isShow">
                    <div class="banner-test">
                        <h1 v-html="img.text.title"></h1>
                        <p v-html="img.text.intro"></p>
                        <router-link class="btn ban-btn" to="/ContactUs">{{$t('common.connect')}}</router-link>
                    </div>
                </div>
                <div class="infor-column infor-column-pc">
                    <ul>
                        <li>
                            <img src="../../assets/images/banner_icon1.png" alt="">
                            <p>{{$t('bannerTips.square')}}</p>
                        </li>
                        <li>
                            <img src="../../assets/images/banner_icon2.png" alt="">
                            <p>{{$t('bannerTips.production')}}</p>
                        </li>
                        <li>
                            <img src="../../assets/images/banner_icon3.png" alt="">
                            <p>{{$t('bannerTips.processes')}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="infor-column infor-column-mobile">
            <ul>
                <li>
                    <img src="../../assets/images/banner_icon1.png" alt="">
                    <p>{{$t('bannerTips.square')}}</p>
                </li>
                <li>
                    <img src="../../assets/images/banner_icon2.png" alt="">
                    <p>{{$t('bannerTips.production')}}</p>
                </li>
                <li>
                    <img src="../../assets/images/banner_icon3.png" alt="">
                    <p>{{$t('bannerTips.processes')}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    // import {getCarousel} from '@/api/api'
    export default {
        data() {
            return {
               carousel:[], 
               isShow:true,
            }
        }, 
        mounted(){
            this.getCarousel();
            this.getScreenWidth()
            $(function(){
                $("#myCarousel").carousel({
                    interval:2500
                })
            })
            window.onresize =()=>{
                this.getScreenWidth()
            }
        },
        methods:{
            // 获取轮播图
            getCarousel () {
                this.$api.carousel.carouselList().then(res=>{
                    console.log(res)
                    this.carousel = res.data.result
                }).catch(
                    (error) => {
                        console.log(error)
                    }
                )
            },
            getScreenWidth(){
                if(document.body.clientWidth>=768){
                    this.isShow = true
                }else{
                    this.isShow=false
                }
            }
        }
    }
</script>

<style scoped>
    .carousel{
        border-bottom: 0.5em solid #29aae1;
    }
    .carousel-indicators{
        bottom: 0;
        margin-bottom: 0;
    }
    .carousel-indicators li{
        margin:1rem;
        width:1.5rem;
        height:1.5rem;
        border-radius: 1.5rem;
        border:none;
        background: #fff;
    }
    .carousel-indicators li.active{
        background:#29aae1;
    }
    .carousel-inner{
        overflow: hidden;
    }
    .banner-test{
        position: absolute;
        left:0;
        top:0;
        padding-top: 5rem;
        padding-left: 10rem;
    }
    .banner-test h1{
        color:#fff;
        font-size: 5rem;
        font-weight: 700;
        text-align: left;
    }
    .banner-test p{
        color:#fff;
        text-align: left;
        font-size: 1.6rem;
        margin: 1.5rem 0;
        font-weight: bold;
        width:50rem;
        height: 5rem;
    }
    .ban-btn{
        margin-top: 5rem;
    }
    .infor-column-mobile{
        display: none;
    }
    .infor-column{
        width:55rem;
        background:rgba(6, 24, 52, .9);
        position: absolute;
        bottom:0;
        right: 0;
        z-index: 11;
        padding:2rem 1.5rem;
    }
    .infor-column img{
        width:5rem;
        height:auto;
    }
    .infor-column ul{
        overflow: hidden;
    }
    .infor-column li{
        float:left;
        width:33.333%;
        text-align: center;
        padding: 0 10px;
    }
    .infor-column li p{
        color:#fff;
        font-size: 1.2rem;
        font-weight: 700;
        margin-top: 1rem;
    }
    @media (min-width: 768px) and (max-width: 1024px){
        .banner-test{
            padding:2rem;
        }
        .banner-test h1{
            font-size: 2.4rem;
        }
        .banner-test p{
            font-size: 1.4rem;
            margin:1rem 0;
        }
        .ban-btn{
            margin-top: 0;
        }
        .infor-column{
            width:40rem;
            padding:0.4rem 0 0.4rem 0.4rem;
        }
        .infor-column img{
            width:4rem;
        }
        .infor-column li p{
            font-size: 1.2rem;
        }
    }
    @media (max-width: 767px){
        .carousel-indicators li{
            width:0.5rem;
            height:0.5rem;
            border-radius: 0.5rem;
            margin:0 0.25rem;
        }
        .carousel-indicators{
            bottom: 0;
        }
        .carousel-inner>.item>img{
            width:100%;
        }
        .banner-test{
            width:100%;
            height: 100%;
            padding:1rem;
            padding-top:2rem;
        }
        .banner-test h1{
            line-height: 1.2;
            font-size: 1.2rem;
        }
        .banner-test p{
            margin: 1rem 0;
            line-height: 1.2;
            font-size: 0.7rem;
            width:100%;
            height: auto;
        }
        .ban-btn{
            margin-top: 6rem;
        }
        .infor-column-pc{
            display: none;
        }
        .infor-column-mobile{
            display: block;
        }
        .infor-column{
            width:100%;
            position: initial;
            padding:1rem;
        }
        .infor-column li{
            margin:0;
            width: 33.333333%;
        }
        .infor-column img{
            width:2rem;
        }
        .infor-column li p{
            font-size: 0.7rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Slide/Slide.vue